// extracted by mini-css-extract-plugin
export default {"PreferenceContainer":"PreferenceContainer_PreferenceContainer__c5j36"};